import { render, staticRenderFns } from "./RirekishoOthersCard.vue?vue&type=template&id=faff4a8e&scoped=true"
import script from "./RirekishoOthersCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoOthersCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoOthersCard.vue?vue&type=style&index=0&id=faff4a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faff4a8e",
  null
  
)

export default component.exports